interface Props {
    className?: string;
}

export function MenuIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.35938 7.48438V6.40625H28.6406V7.48438H4.35938ZM4.35938 27.5938V26.5156H28.6406V27.5938H4.35938ZM4.35938 16.4609H28.6406V17.5391H4.35938V16.4609Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
}
